import { faDiamondExclamation, faSquare, faSquareXmark } from '@fortawesome/pro-regular-svg-icons';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as style from './style.module.css';

export const InputCheckBox = ({
    name = '',
    checked = false,
    disabled = false,
    onChange = () => {},
    onBlur = () => {},
    onFocus = () => {},
    mode = 'normal',
    ariaLabel = undefined,
}) => {
    const getIcon = () => {
        if (mode === 'normal') {
            return checked ? faSquareCheck : faSquare;
        }
        if (mode === 'correct') {
            return faSquareCheck;
        }
        if (mode === 'error') {
            return faSquareXmark;
        }
        if (mode === 'warning') {
            return faDiamondExclamation;
        }
        return faSquare;
    };

    return (
        <>
            <input
                type="checkbox"
                name={name}
                aria-label={ariaLabel}
                checked={checked}
                className={style.inputCheckbox}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                disabled={disabled}
            />
            <div className={style.iconcontainer}>
                <FontAwesomeIcon
                    className={`${style[mode]} ${checked ? style.selected : ''} ${disabled ? style.disabled : ''}`}
                    icon={getIcon()}
                />
            </div>
        </>
    );
};
